import { css as _css } from "@emotion/core";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import FilledPinIcon from '@domain-group/fe-co-icon/lib/js/filled-pin';
import LinkIcon from '@domain-group/fe-co-icon/lib/js/link';
import { useAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { EmailIcon } from '@domain-group/fe-co-icon';
import AllhomesAgencyModel from './agency-model';
import * as styles from './agency-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgencyCard = props => {
  var _ref = useAllhomesContext() || {},
    isEuUser = _ref.isEuUser;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleEmailClick = () => {
    sendEvent('email-click');
    props.enquiryFormCallback({
      id: props.id,
      title: "Contact ".concat(props.name),
      logo: props.images.profilePhoto,
      type: 'AGENCY',
      source: 'Header'
    });
  };
  var addresses = [props.address || undefined, ...props.additionalOffices.map(office => office === null || office === void 0 ? void 0 : office.address)].filter(address => address).slice(0, 5);
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.agencyCard, !props.images.profilePhoto && styles.noProfilePhoto])
  }, ___EmotionJSX("div", {
    css: styles.left
  }, ___EmotionJSX("h1", {
    css: styles.name
  }, props.name), addresses.length > 0 && addresses.map(address => ___EmotionJSX("div", {
    css: styles.address
  }, ___EmotionJSX(FilledPinIcon, {
    size: "small",
    css: styles.addressAnchorIcon
  }), ___EmotionJSX("div", {
    css: styles.addressText
  }, ___EmotionJSX("span", {
    css: styles.addressLine1
  }, address.street), ___EmotionJSX("span", {
    css: styles.addressLine2
  }, "\xA0", address.suburb, ", ", address.state, " ", address.postcode)))), props.website && ___EmotionJSX("div", {
    css: styles.websiteWrapper
  }, ___EmotionJSX("span", {
    css: styles.website
  }, ___EmotionJSX("a", {
    "data-testid": "agency-card-website",
    css: styles.websiteAnchor,
    href: props.website,
    onClick: () => sendEvent('website-click'),
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "website"
  }, ___EmotionJSX(LinkIcon, {
    size: "small",
    css: styles.websiteIcon
  }))))), ___EmotionJSX("div", {
    css: styles.right
  }, props.phone && ___EmotionJSX(CallButton, {
    css: styles.phoneButton,
    phone: props.phone,
    showIcon: {
      beforeClick: true,
      afterClick: true
    }
  }), !isEuUser && props.emailContactable && ___EmotionJSX(Button, {
    appearance: "accent",
    icon: ___EmotionJSX(EmailIcon, null),
    iconPosition: "left",
    onClick: handleEmailClick,
    css: styles.emailButton
  }, "Email")));
};
AllhomesAgencyCard.propTypes = _objectSpread({
  enquiryFormCallback: PropTypes.func.isRequired
}, AllhomesAgencyModel);
AllhomesAgencyCard.defaultProps = {
  images: {} // eslint-disable-line
};
export default AllhomesAgencyCard;